<mat-chip-set
  [style.paddingLeft]="paddingLeft"
  [style.paddingRight]="paddingRight"
  [style.paddingTop]="paddingTop"
  [style.paddingBottom]="paddingBottom"
  [style.marginTop]="marginTop"
  [style.marginLeft]="marginLeft"
  [style.marginBottom]="marginBottom"
  [style.marginRight]="marginRight"
  [ngClass]="classes"
>
  @for (widget of input.children; track widget) {
    <ng-container [dynamicWidget]="widget" [context]="context" />
  }
</mat-chip-set>
